import RelayConfirmChannel from './RelayConfirmChannel'
import RelayConfirmLecture from './RelayConfirmLecture'

export {
    RelayConfirmChannel,
    RelayConfirmLecture,
}


// WEBPACK FOOTER //
// ./src/components/relayConfirm/index.js